export default __webpack_public_path__ + "static/media/pin.d87cd96f.png";